import React from "react";
import musicInstrumentsImage from '../../images/instruments-musique.jpg';
import CategoryPage from '../CategoryPage';

function InstrumentsDeMusiquePage() {
    const details = [
        "Violon",
        "Violoncelle",
        "Contrebasse",
        "Guitare",
        "Harpe",
        "Flûte traversière en bois",
        "Saxophone (surtout vintage)",
        "Trompette",
        "Cor d’harmonie",
        "Clarinette en bois",
        "Piano à queue ancien",
        "Accordéon",
        "Orgue de barbarie",
        "Mandoline",
        "Luth",
        "Cymbalum",
        "Tuba",
        "Basson ancien",
        "Clavichord",
        "Chantonnement (chants traditionnels et instruments associés)",
    ];

    return (
        <CategoryPage
            title="Instruments de Musique Anciens"
            image={musicInstrumentsImage}
            description="En tant qu’antiquaire expert, je me spécialise dans l’acquisition d’instruments de musique classiques anciens, qu’il s’agisse de violons, violoncelles, contrebasses, saxophones, harpes ou guitares. Quel que soit leur état, même s’ils nécessitent des restaurations, chaque instrument possède une histoire et une valeur uniques. Je vous propose une évaluation experte et un prix équitable, en respectant l’héritage de chaque pièce. Si vous souhaitez vendre un instrument, n’hésitez pas à me contacter pour une offre juste et un accompagnement personnalisé."
            details={details}
        />
    );
}

export default InstrumentsDeMusiquePage;
